import {
	ReportApi,
	InternshipEngagementType,
	InternshipType,
	SortDirectionEnum,
	PoliJobsReportSortFieldEnum,
	StudentYearEnum,
} from "../Api";
import { getAuthConfiguration } from "./configuration";
import { arrayParamAjust } from "../utils/dataUtils";

const ReportApiFactory = () => new ReportApi(getAuthConfiguration());

export const getProfessorProposalReport = (
	page: number,
	pageSize: number,
	engagementType: InternshipEngagementType,
	studyProgram: Array<string>,
	year?: number,
	facultyId?: string,
	departmentId?: string
) =>
	ReportApiFactory().apiReportGetProfessorProposalReportGet({
		page,
		pageSize,
		engagementType,
		studyProgram: arrayParamAjust(studyProgram),
		universityYear: year,
		facultyId: facultyId,
		departmentId: departmentId,
	});

export const getMissingStudentProjectEnrollmentReport = (
	page: number,
	pageSize: number,
	studyCycle: string,
	universityYear: number,
	facultyId: string,
	studyProgram: Array<string>
) =>
	ReportApiFactory().apiReportGetMissingStudentProjectEnrollmentReportGet({
		page,
		pageSize,
		studyCycle,
		universityYear,
		facultyId,
		studyProgram: arrayParamAjust(studyProgram),
	});

export const getProjectAllocationReport = (
	page: number,
	pageSize: number,
	engagementType: InternshipEngagementType,
	studyProgram: Array<string>,
	universityYear: number,
	facultyId?: string
) =>
	ReportApiFactory().apiReportGetProjectAllocationReportGet({
		page,
		pageSize,
		engagementType,
		studyProgram: arrayParamAjust(studyProgram),
		universityYear,
		facultyId,
	});

export const getMissingStudentPracticeInternshipEnrollmentReport = (
	page: number,
	pageSize: number,
	year: StudentYearEnum,
	studyProgram: Array<string>,
	universityYear: number,
	facultyId: string | null
) =>
	ReportApiFactory().apiReportGetMissingStudentPracticeInternshipEnrollmentReportGet(
		{
			page,
			pageSize,
			year,
			studyProgram: arrayParamAjust(studyProgram),
			universityYear,
			facultyId: facultyId ?? undefined,
		}
	);

export const getPracticeInternshipAllocationReport = (
	page: number,
	pageSize: number,
	studyProgram: Array<string>,
	internshipType?: InternshipType,
	universityYear?: number,
	facultyId?: string,
	studentYear?: StudentYearEnum
) =>
	ReportApiFactory().apiReportGetPracticeInternshipAllocationReportGet({
		page,
		pageSize,
		internshipType,
		studyProgram: arrayParamAjust(studyProgram),
		universityYear,
		facultyId,
		year: studentYear,
	});

export const getStudentAllocationPerDomainReport = (
	page: number,
	pageSize: number,
	internshipType?: InternshipType,
	universityYear?: number,
	facultyId?: string
) =>
	ReportApiFactory().apiReportGetStudentAllocationPerDomainReportGet({
		internshipType,
		universityYear,
		facultyId,
		page,
		pageSize,
	});

export const getPracticeInternshipPerDomainReport = (
	page: number,
	pageSize: number,
	internshipType?: InternshipType,
	universityYear?: number,
	facultyId?: string
) =>
	ReportApiFactory().apiReportGetPracticeInternshipsPerDomainReportGet({
		page,
		pageSize,
		internshipType,
		universityYear,
		facultyId,
	});

export const getSummerSchoolsReport = (
	page: number,
	pageSize: number,
	studyProgram: Array<string>,
	universityYear?: number,
	facultyId?: string | null,
	internshipType?: InternshipType,
	studyCycle?: string
) =>
	ReportApiFactory().apiReportGetSummerSchoolsReportGet({
		page,
		pageSize,
		studyProgram: arrayParamAjust(studyProgram),
		universityYear,
		facultyId: facultyId ?? undefined,
		internshipType,
		studyCycle,
	});

export const getCompaniesFacultyAccordsReport = () =>
	ReportApiFactory().apiReportGetCompaniesFacultyAccordsReportGet({});

export const getCompanyContactsReport = (
	namePattern?: string,
	page?: number,
	pageSize?: number,
	companyId: string | undefined = undefined
) =>
	ReportApiFactory().apiReportGetCompanyContactsReportGet({
		namePattern,
		companyId,
		page,
		pageSize,
	});

export const getAllCompaniesContactsReport = () =>
	ReportApiFactory().apiReportGetAllCompaniesContactsReportGet();

export interface PoliJobsCvAccessReportProps {
	search?: string;
	page?: number;
	pageSize?: number;
	sortKey?: PoliJobsReportSortFieldEnum;
	sort?: SortDirectionEnum;
}

export const getAllPoliJobsCvAccessReport = (
	props: PoliJobsCvAccessReportProps
) => {
	const {
		search: namePattern,
		page,
		pageSize,
		sortKey: sortField,
		sort: sortDirection,
	} = props;

	return ReportApiFactory().apiReportGetAllPoliJobsCvAccessReportGet({
		namePattern,
		page,
		pageSize,
		sortField,
		sortDirection,
	});
};
